
import useNavigation from "@/utils/useNavigate";
import { useSearchParams } from "react-router-dom";

import { useUnmount } from "ahooks";
import React, { useEffect, useRef, useState } from "react";
import styles from "./index.module.less";

interface TopNavBarProps {
  onSearchClick?: () => boolean | void;
}

const TopNavBar: React.FC<TopNavBarProps> = ({  onSearchClick }) => {
  const { navigate2Home, navigate2H5 } = useNavigation();
  const [search] = useSearchParams();
  const shopId = search.get("shopId");
  const distributorId = search.get("distributorId");
  const timerRef = useRef<number | null>(null);
  const [showBackButton, setShowBackButton] = useState(false);

  useEffect(() => {
    if (history.length > 1) {
      setShowBackButton(true);
    }
  }, []);

  useUnmount(() => {
    if (timerRef.current !== null) {
      window.clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  });

  // 点击回退
  const handleBackClick = () => {
    try {
      if (history.length > 1) {
        const url = location.href;
        history.back();

        if (timerRef.current !== null) {
          window.clearTimeout(timerRef.current);
        }

        timerRef.current = window.setTimeout(() => {
          if (location.href === url) {
            navigate2Home();
          }
          timerRef.current = null;
        }, 500);
      } else {
        navigate2Home();
      }
    } catch (error) {
      console.error("返回操作失败:", error);
      navigate2Home();
    }
  };

  // 点击首页
  const handleHomeClick = () => {
    navigate2Home();
  };



  // 点搜素图标，跳转素材搜索页
  const handleSearchClick = () => {
    const result = onSearchClick?.();
    if (result === false) {
      return;
    }
    navigate2H5(`/mx-shop-micro/enticeSearch?shopId=${shopId}&channel=h5Mall&distributorId=${distributorId}`);
  };


  return (
    <div className={styles.topNavBar}>
      {/* 左侧 */}
      <div className={styles.left}>
        {/* 返回按钮 - 条件渲染 */}
        {showBackButton && (
          <>
            <img
              className={styles.back}
              src="https://akim-oss.aikucun.com/f1b739aab1d8afaf3cf03b6e5edf883ae10b3eac_1749718731428_34.png"
              alt="返回"
              onClick={handleBackClick}
            />
            <div className={styles.divider}></div>
          </>
        )}

        {/* 首页 */}
        <div className={styles.home} onClick={handleHomeClick}>
          <img
            src="https://akim-oss.aikucun.com/b633853dfcdaf4f7c4c45711035e5012afa449f9_1749718718546_73.png"
            alt=""
            className={styles.homeIcon}
          />
          <span className={styles.homeText}>首页</span>
        </div>
      </div>

      {/* 右侧 */}
      <div className={styles.right}>
        {/* 搜索 */}
        <img
          className={styles.search}
          src="https://akim-oss.aikucun.com/6f3c2ddd5945a2b570b763fc6f0238b0a3d266d5_1749718718567_55.png"
          alt=""
          onClick={handleSearchClick}
        />
      </div>
    </div>
  );
};

export default TopNavBar;
